import React, { useState, useEffect } from "react";
import { useParams, Link, Outlet, useNavigate } from "react-router-dom";
import { useQuery, useMutation, useQueryClient } from "react-query";
import useApi from "../../hooks/useApi";
import usePagination from "../../hooks/usePagination";
import { NavigateBackButton } from "../../widgets";
import moment from "moment";

import ClaimItemStatus from "../../widgets/ClaimItemStatus";
import useClaimStatus from "../../hooks/useClaimStatus";

import { CSVLink, CSVDownload } from "react-csv";

const ClientAccountClaims = () => {
  const { status = "" } = useParams();
  const { Paginate, searchParamString } = usePagination();
  const { api, abortSignal, auth } = useApi();
  const navigate = useNavigate();
  const { claimStage } = useClaimStatus();

  const getPolicies = async (searchString, policyStatus) => {
    try {
      const url = `/client-accounts/claims${searchString}/${policyStatus}`;
      const { data } = await api.list(url);
      return data;
    } catch (error) {
      throw new Error("failed to fetch records");
    }
  };

  const { data: policies } = useQuery(
    ["policies", searchParamString, status, auth],
    ({ queryKey }) => getPolicies(queryKey[1], queryKey[2])
  );

  const csvData = [
    [
      "Claim ID",
      "Incident Date",
      "Report Date",
      "Incident Description",
      "Policy Info",
      "Policy Type",
      "Policy Number",
      "Company",
      "Status",
    ],
  ];

  policies?.forEach((policy) => {
    const pdata = [
      policy?.id,
      policy?.incidentDate,
      policy?.reportDate,
      policy?.incidentDescription,
      policy?.ClientPolicy?.title,
      policy?.PolicyType?.name + " - " + policy?.Product?.name,
      policy?.ClientPolicy?.policyNumber,
      policy?.Company?.name,
      claimStage(policy?.stage),
    ];

    csvData.push(pdata);
  });

  return (
    <>
      <section id="content" className="content">
        <div className="content__header content__boxed">
          <div className="content__wrap">
            {/* <!-- Breadcrumb --> */}
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/client-policies">My Claims</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  List
                </li>
              </ol>
            </nav>
            {/* <!-- END : Breadcrumb --> */}
            <h1 className="page-title mb-0 mt-2">Claims</h1>
            <p className="lead">List of all claims made</p>
            <div className="d-md-flex align-items-baseline my-3">
              <CSVLink
                data={csvData}
                filename={"claims.csv"}
                className="btn btn-success btn-sm"
                target="_blank"
              >
                CSV Export
              </CSVLink>

              <div className="d-flex align-items-center gap-1 text-nowrap ms-auto mb-3">
                <NavigateBackButton />
              </div>
            </div>
          </div>
        </div>
        <div className="content__boxed">
          <div className="content__wrap">
            <div className="table-responsive bg-white">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Incident Date</th>
                    <th>Policy Info</th>
                    <th>Type</th>
                    <th>Company</th>
                    <th>Expires</th>
                    <th>Policy Number</th>
                    <th className="text-center">Status</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {policies &&
                    policies.map((policy) => (
                      <tr key={policy.id}>
                        <td>{moment(policy?.incidentDate).format("LL")}</td>
                        <td>{policy?.ClientPolicy?.title}</td>
                        <td>
                          {policy?.PolicyType?.name}
                          <br />
                          {policy?.Product?.name}
                        </td>
                        <td>
                          <span className="fw-bold">
                            {policy?.Company?.name}
                          </span>
                        </td>
                        <td>
                          <>
                            <span>
                              {moment(policy?.expires).format("DD/MM/YYYY") ||
                                ""}
                            </span>
                            <p className="text-muted">
                              {policy?.expires &&
                                moment().to(moment(policy?.expires))}
                            </p>
                          </>
                        </td>
                        <td>{policy?.ClientPolicy?.policyNumber}</td>

                        <td className="text-center fs-5">
                          <ClaimItemStatus status={policy?.stage} />
                        </td>
                        <td className="text-center">
                          <div className="d-flex flex-wrap justify-content-center">
                            <div className="btn-group">
                              <Link
                                to={`/client-account/claims/${policy?.id}`}
                                title="View policy"
                                className="btn btn-icon btn-outline-primary"
                              >
                                <i className="bi bi-pencil-square fs-4 text-success"></i>
                              </Link>
                              {/* )} */}
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              <Paginate />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ClientAccountClaims;
